import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Articles.css';
import { articlesConfig } from '../config/articles';

const Articles = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');

  // Convert articles config to array format with IDs
  const articles = Object.entries(articlesConfig).map(([id, article]) => ({
    id: parseInt(id),
    ...article
  }));

  const categories = [
    { id: 'all', name: 'All Articles' }
  ];

  const filteredArticles = articles.filter(article => {
    const matchesSearch = article.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         article.excerpt.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         article.author.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = selectedCategory === 'all' || article.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  const getCategoryIcon = (category) => {
    const icons = {
      'Architecture': 'fas fa-building',
      'Security': 'fas fa-shield-alt',
      'DevOps': 'fas fa-cogs',
      'Frontend': 'fas fa-code',
      'Database': 'fas fa-database',
      'Testing': 'fas fa-vial',
      'Cloud': 'fas fa-cloud'
    };
    return icons[category] || 'fas fa-file-alt';
  };

  return (
    <div className="articles-page">
      <div className="articles-hero">
        <div className="container">
          <h1>Articles & Insights</h1>
          <p>Stay updated with the latest trends, best practices, and insights from software engineering experts</p>
        </div>
      </div>

      <div className="container">
        <div className="articles-filters">
          <div className="search-box">
            <i className="fas fa-search"></i>
            <input
              type="text"
              placeholder="Search articles..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="category-filters">
            {categories.map(category => (
              <button
                key={category.id}
                className={`category-btn ${selectedCategory === category.id ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category.id)}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>

        <div className="articles-content">
          {filteredArticles.length === 0 ? (
            <div className="no-results">
              <i className="fas fa-search"></i>
              <h3>No articles found</h3>
              <p>Try adjusting your search terms or category filter</p>
            </div>
          ) : (
            <div className="articles-grid">
              {filteredArticles.map(article => (
                <article key={article.id} className={`article-card ${article.featured ? 'featured' : ''}`}>
                  <div className="article-image">
                    <i className={getCategoryIcon(article.category)}></i>
                    {article.featured && <span className="featured-badge">Featured</span>}
                  </div>
                  <div className="article-content">
                    <div className="article-meta">
                      <span><i className="fas fa-calendar"></i> {article.date}</span>
                      <span><i className="fas fa-user"></i> {article.author}</span>
                      <span><i className="fas fa-clock"></i> {article.readTime}</span>
                    </div>
                    <h3>{article.title}</h3>
                    <p className="article-excerpt">{article.excerpt}</p>
                    <div className="article-tags">
                      {article.tags.map(tag => (
                        <span key={tag} className="article-tag">{tag}</span>
                      ))}
                    </div>
                    <div className="article-footer">
                      <span className="article-category">
                        <i className={getCategoryIcon(article.category)}></i>
                        {article.category}
                      </span>
                      <Link 
                        to={`/articles/${article.id}`} 
                        className="btn btn-outline"
                      >
                        Read Article
                      </Link>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>

        <div className="articles-sidebar">
          <div className="sidebar-section">
            <h3>Featured Authors</h3>
            <div className="authors-list">
              {['US Society of Software  Engineers'].map(author => (
                <div key={author} className="author-item">
                  <div className="author-avatar">
                    <i className="fas fa-user"></i>
                  </div>
                  <div className="author-info">
                    <h4>{author}</h4>
                    <p>Senior Software Engineer</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Articles; 